import { c as _c } from "react/compiler-runtime";
import { Input as InputPrimitive } from '@base-ui/react/input';
import { cn } from 'cn';
type InputProps = React.ComponentProps<'input'>;
export function Input(props) {
  const $ = _c(10);
  let className;
  let rest;
  let type;
  if ($[0] !== props) {
    ({
      className,
      type,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = rest;
    $[3] = type;
  } else {
    className = $[1];
    rest = $[2];
    type = $[3];
  }
  let t0;
  if ($[4] !== className) {
    t0 = cn("h-9 w-full min-w-0 rounded-4xl border border-input bg-input/30 px-3 py-1 text-base transition-colors outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20 md:text-sm dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40", className);
    $[4] = className;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== rest || $[7] !== t0 || $[8] !== type) {
    t1 = <InputPrimitive type={type} data-slot="input" className={t0} {...rest} />;
    $[6] = rest;
    $[7] = t0;
    $[8] = type;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}